module.exports = __webpack_public_path__ + "img/ship__5_@2x.4ac3fd22.png";